import { PageHeader } from "@/components/layout/PageHeader";
import { ExportCard } from "@/components/data/ExportCard";
import { ImportCard } from "@/components/data/ImportCard";

/**
 * Exportar e importar os dados do projeto: o Firestore e o Storage juntos,
 * num ZIP, em dois passos de cada lado.
 *
 * Os dois vão juntos porque um depende do outro: o Firestore guarda as URLs e
 * os caminhos dos arquivos do Storage. O servidor devolve cada arquivo no
 * mesmo caminho e com o mesmo token, e as URLs importadas continuam abrindo o
 * arquivo certo (o formato e as regras estão no zepadoca-functions, em
 * `utils/dataTransfer.ts`).
 */
export default function Data() {
  return (
    <>
      <PageHeader
        title="Dados"
        description="Exportação e importação do Firestore e do Storage juntos, num arquivo ZIP."
      />
      <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
        <ExportCard />
        <ImportCard />
      </div>
    </>
  );
}
